import { api } from 'services/api';

const patientService = api
  .enhanceEndpoints({ addTagTypes: ['Patients', 'PassivePatients'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      // patients: builder.query<ResultModel<PatientModel[]>, void>({
      //   query: () => ({
      //     url: `/443376B83AD660/PatientsByPetOwner`,
      //     method: 'POST',
      //   }),
      //   providesTags: (result) =>
      //     result?.data
      //       ? [
      //           ...result.data.map(({ id }) => ({ type: 'Patients' as const, id })),
      //           { type: 'Patients', id: 'LIST' },
      //         ]
      //       : [{ type: 'Patients', id: 'LIST' }],
      //   extraOptions: { isProfile: true },
      // }),
      patients: builder.query<ResultModel<PatientModel[]>, PatientsByPetOwnerRequest>({
        query: (body) => ({
          url: `/443376B83AD660/PatientsByPetOwner`,
          method: 'POST',
          body,
        }),
        providesTags: (result) =>
          result?.data
            ? [
                ...result.data.map(({ id }) => ({ type: 'Patients' as const, id })),
                { type: 'Patients', id: 'LIST' },
              ]
            : [{ type: 'Patients', id: 'LIST' }],
        extraOptions: { isProfile: true },
      }),
      passivePatients: builder.query<ResultModel<PatientModel[]>, void>({
        query: () => ({
          url: `/443376B83AD660/PassiveRelations`,
          method: 'POST',
        }),
        providesTags: (result) =>
          result?.data
            ? [
                ...result.data.map(({ id }) => ({ type: 'PassivePatients' as const, id })),
                { type: 'PassivePatients', id: 'LIST' },
              ]
            : [{ type: 'PassivePatients', id: 'LIST' }],
        extraOptions: { isProfile: true },
      }),
      createPatient: builder.mutation<ResultModel<PatientModel>, PatientCreateRequest>({
        query: (body) => ({
          url: `/443376B83AD660/Create`,
          method: 'POST',
          body,
        }),
        invalidatesTags: [{ type: 'Patients', id: 'LIST' }],
        extraOptions: { isProfile: true },
      }),
      updatePatient: builder.mutation<ResultModel<void>, PatientUpdateRequest>({
        query: (body) => ({
          url: `/443376B83AD660/Update`,
          method: 'POST',
          body,
        }),
        invalidatesTags: [{ type: 'Patients', id: 'LIST' }],
        extraOptions: { isProfile: true },
      }),
      deletePatient: builder.mutation<ResultModel<void>, PatientDeleteRequest>({
        query: (body) => ({
          url: `/443376B83AD660/Delete`,
          method: 'POST',
          body,
        }),
        invalidatesTags: [
          { type: 'Patients', id: 'LIST' },
          { type: 'PassivePatients', id: 'LIST' },
        ],
        extraOptions: { isProfile: true, isShowErrorMessage: false },
      }),
      vaccines: builder.query<ResultModel<Vaccine[]>, VaccinesRequest>({
        query: (body) => ({
          url: `/443376B83AD660/Vaccines`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
      }),
      vaccineReport: builder.query<ResultModel<VaccineReportResponse>, void>({
        query: () => ({
          url: `/443376B83AD660/VaccineReport`,
          method: 'POST',
        }),
        extraOptions: { isProfile: true },
      }),
      visits: builder.query<ResultModel<Visit[]>, VisitsRequest>({
        query: (body) => ({
          url: `/443376B83AD660/GetVisits`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
      }),
      labReports: builder.query<ResultModel<LabReport[]>, LabReportsRequest>({
        query: (body) => ({
          url: `/443376B83AD660/GetLabReports`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
      }),
      radReports: builder.query<ResultModel<RadReport[]>, RadReportsRequest>({
        query: (body) => ({
          url: `/443376B83AD660/GetRadReports`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
      }),
      otherReports: builder.query<ResultModel<OtherReport[]>, OtherReportsRequest>({
        query: (body) => ({
          url: `/443376B83AD660/GetPatientOtherProcessReports`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
      }),
      pdfReport: builder.query<ResultModel<PdfReport>, PdfReportRequest>({
        query: (body) => ({
          url: `/443376B83AD660/GetPdfReport`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
      }),
      pacsReport: builder.query<ResultModel<PacsReport>, PacsReportRequest>({
        query: (body) => ({
          url: `/443376B83AD660/RadiologyPacsLink`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
      }),
    }),
  });

export const {
  usePatientsQuery,
  usePassivePatientsQuery,
  useCreatePatientMutation,
  useUpdatePatientMutation,
  useDeletePatientMutation,
  useVaccinesQuery,
  useVaccineReportQuery,
  useVisitsQuery,
  useLabReportsQuery,
  useRadReportsQuery,
  useOtherReportsQuery,
  usePdfReportQuery,
  usePacsReportQuery,
} = patientService;

